import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from "@sentry/angular";
import { getQueryString,getCookie } from './app/helper';
import { RELEASE_VERSION } from 'sentry.constants';
const SENTRY_SERVICE_NAME = 'trip-view-ui'//This should match project name in sentry


let empGuid = getQueryString("empGuid") || getCookie("empGuid");
let buid = getQueryString("buid") || getCookie("buid");

if (environment.production) {
  enableProdMode();
}


if (environment.sentry) { // environment.sentry.project1 <- for multiple projects
  Sentry.init({
    environment: environment.tag,
    release: `${SENTRY_SERVICE_NAME}@${RELEASE_VERSION}`,
    dsn: environment.sentry, // environment.sentry.project1 <- for multiple projects
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.replayIntegration()
    ],
    initialScope: {
      tags: {
        empGuid: empGuid,
        buid: buid,
      },
      user: {
        id: empGuid,
        buid: buid
      }
    },
    ignoreErrors: [
      /\bHttp failure\b/, 
      /\bloginRequest\b/, 
      /\bServer returned code (400|401|403|404|500|501|502|503|504)\b/,
      /\bgoogle is not defined\b/
    ],
    // Performance Monitoring
    tracesSampleRate: 0.01, //  Capture 1% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost"],
    // Profiling
    profilesSampleRate: 1.0, // Profile 100% of the transactions. This value is relative to tracesSampleRate
  });
 }

platformBrowserDynamic().bootstrapModule(AppModule).then(ref => {
  // Ensure Angular destroys itself on hot reloads.
  if (window['ngRef']) {
    window['ngRef'].destroy();
  }
  window['ngRef'] = ref;

  // Otherwise, log the boot error
}).catch(err => console.error(err));
